// FHT Swagger jQuery client V2
/**
 * FHT.Common.Types.ImageSizeType, FHT.Common.Types, Version=0.0.0.0, Culture=neutral, PublicKeyToken=null
 */
/**
* FHT.Common.Types.ImageSizeType, FHT.Common.Types, Version=0.0.0.0, Culture=neutral, PublicKeyToken=null
*/
// mark 1 model enum
export enum ImageSizeTypeEnum {
    Large = "Large",
    Thumbnail44whFill = "Thumbnail44whFill",
    Thumbnail100whFill = "Thumbnail100whFill",
    Thumbnail200whFill = "Thumbnail200whFill",
    Thumbnail300whFill = "Thumbnail300whFill",
    Thumbnail400_300whFill = "Thumbnail400_300whFill",
    Thumbnail100wh7rFill = "Thumbnail100wh7rFill",
    Thumbnail80wh40crFill = "Thumbnail80wh40crFill",
    Thumbnail200w = "Thumbnail200w",
    Thumbnail200whFit = "Thumbnail200whFit",
    Thumbnail750_440whFill = "Thumbnail750_440whFill",
    Thumbnail1920_500whFill = "Thumbnail1920_500whFill",
    Thumbnail1600_500whFill = "Thumbnail1600_500whFill",
    Thumbnail1440_500whFill = "Thumbnail1440_500whFill",
    Thumbnail1280_500whFill = "Thumbnail1280_500whFill",
    Thumbnail440whFill = "Thumbnail440whFill",
    Thumbnail500hAlpha = "Thumbnail500hAlpha",
    Thumbnail120_60whLongSideAlpha = "Thumbnail120_60whLongSideAlpha",
    Thumbnail100whLongSideAlpha = "Thumbnail100whLongSideAlpha",
    Thumbnail80whAlphaFit = "Thumbnail80whAlphaFit",
    Thumbnail200whAlphaFill = "Thumbnail200whAlphaFill",
    AssetsOrigin = "AssetsOrigin",
    AssetsGif = "AssetsGif",
    Thumbnail44whaFill = "Thumbnail44whaFill",
    Thumbnail1920_728whFill = "Thumbnail1920_728whFill",
    Thumbnail1600_728whFill = "Thumbnail1600_728whFill",
    Thumbnail1440_728whFill = "Thumbnail1440_728whFill",
    Thumbnail1280_728whFill = "Thumbnail1280_728whFill",
    Thumbnail1920_600whFill = "Thumbnail1920_600whFill",
    Thumbnail1600_600whFill = "Thumbnail1600_600whFill",
    Thumbnail1440_600whFill = "Thumbnail1440_600whFill",
    Thumbnail1280_600whFill = "Thumbnail1280_600whFill"
}
